/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-03, 10:20:17
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-06, 14:54:44
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import Vue from 'vue';
import store from '@/store';
import { mapGetters } from 'vuex';

// COMPONENTS //////////////////////////////////////////////////////////////////
import MyAccountBanner from '@/components/MyAccount/MyAccountBanner';
import MyInvoicesCard from '@/components/MyAccount/MyInvoicesCard';
import MyNumberCard from '@/components/MyAccount/MyNumberCard';
import MyOfferCard from '@/components/MyAccount/MyOfferCard';
import MyRechargesCard from '@/components/MyAccount/MyRechargesCard';
import PromotionInfoCard from '@/components/MyAccount/PromotionInfoCard';
import PrepaidBestsellersCard from '@/components/MyAccount/PrepaidBestsellersCard';
import MyIndividualAccountNumber from '@/components/MyAccount/MyIndividualAccountNumber';
import MockCardOnMyAccount from '@/components/Common/MockCardOnMyAccount';

// CONTAINER ///////////////////////////////////////////////////////////////////
const MyAccount = {
  components: {
    MyAccountBanner,
    MyInvoicesCard,
    MyNumberCard,
    MyOfferCard,
    MyRechargesCard,
    PromotionInfoCard,
    PrepaidBestsellersCard,
    MyIndividualAccountNumber,
    MockCardOnMyAccount,
  },
  store,

  computed: {
    ...mapGetters(['subscriber', 'mainComponentsVisibility', 'lastInvoice', 'pendingStoreActions', 'acl']),
    mainComponents() {
      return Object.keys(this.mainComponentsVisibility)
        .filter(name => name !== 'MyAccountBanner');
    },
  },

  template: `
    <div class="container-fluid animated fadeIn">
      <div class="row" v-if="mainComponentsVisibility['MyAccountBanner']">
        <div class="col-xs-12">          
          <my-account-banner />          
        </div>
      </div>
      <div class="row" v-if="!pendingStoreActions.includes('getInformationAboutMainComponentsVisibility')">
        <template v-for="component in mainComponents">
          <div class="col-md-6 col-xs-12" v-if="mainComponentsVisibility[component]">
            <component :is="component"
              :subscriber="subscriber" 
              :last-invoice="lastInvoice"
              :acl="acl"
            />
          </div>
        </template>
      </div>
      <MockCardOnMyAccount v-if="pendingStoreActions.includes('getInformationAboutMainComponentsVisibility')" />      
    </div>
  `,
};

export default Vue
  .component('MyAccount', MyAccount);



// WEBPACK FOOTER //
// ./src/containers/MyAccount/index.js